import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';
import { ErrorLink } from 'apollo-link-error';
import { captureEvent, Severity } from '@sentry/browser';

export function makeClient (name, url) {
    return new ApolloClient({
        name,
        link: RetryLink.from([
            // Error handling
            new ErrorLink((error) => {
                const { graphQLErrors, networkError } = error;

                captureEvent({
                    message: 'Apollo error',
                    level: Severity.Error,
                    extra: error,
                });

                if (graphQLErrors) {
                    graphQLErrors.forEach(console.error);
                }

                if (networkError) {
                    console.error(networkError);
                }
            }),
            // Retry on network errors
            new RetryLink({
                delay: {
                    delay: 200,
                    jitter: true,
                },
                attempts: {
                    max: 5,
                },
            }),
            // Terminating link to perform the request
            new HttpLink({
                uri: `${url}graphql`,
                credentials: 'include',
            }),
        ]),
        cache: new InMemoryCache(),
        version: process.env.CI_COMMIT_SHORT_SHA || 'local',
    });
}
